import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDk = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 370 280",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 370,
			height: 280,
			fill: "#c60c30"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 280,
			x: 120,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 370,
			height: 40,
			y: 120,
			fill: "#fff"
		})
	]
});
export default SvgDk;
